<div id="other-filters">
  <div class="row">
    <p class="title">Outros</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <div class="row">
    <app-input class="one-half" id="cargo" label="Cargo" placeholder="">
    </app-input>
  </div>

  <app-select class="row" labelText="Corretor" height="110" field="name" sizeList="3"
    [disabled]="!dropdownOptions.length" [listItems]="dropdownOptions">
  </app-select>

  <app-input class="row" id="texto-interno" label="Texto interno" placeholder="">
  </app-input>
</div>